// react
import { type ReactNode, useEffect, useId } from 'react';

// components
// shared components
import { useGlobalAlert } from '@/components/ui/alert/GlobalAlertContext';

interface AlertProviderProps {
  enabled: boolean;

  severity: 'success' | 'info' | 'warning' | 'error';

  title?: string;

  message: ReactNode;

  action?: ReactNode;
}

export function useAlertProvider({
  enabled,
  severity,
  title,
  message,
  action,
}: AlertProviderProps) {
  const { showAlert, clearAlert } = useGlobalAlert();
  const ownerId = useId();

  useEffect(() => {
    if (!enabled) {
      clearAlert(ownerId);
      return;
    }

    showAlert({
      severity,
      title,
      message,
      action,
      ownerId,
    });

    return () => {
      clearAlert(ownerId);
    };
  }, [
    clearAlert,
    enabled,
    showAlert,
    severity,
    title,
    message,
    action,
    ownerId,
  ]);
}
